<template>
  <van-field name="uploader" :label="label">
    <template #input>
      <!-- <van-uploader
        :max-count="1"
        :after-read="afterRead"
        :before-delete="deleteafterRead"
        v-model="MerchantEntrancePhoto"
      />-->
      <van-uploader :max-count="1" :after-read="afterRead" v-model="MerchantEntrancePhoto" />
    </template>
  </van-field>
</template>
<script>
import moment from "moment";
import getUpToken from "@/api/getUpToken";
import axios from "axios";
export default {
  props: ["label"],
  data() {
    return {
      MerchantEntrancePhoto: []
      // data: []
    };
  },
  // watch: {
  //   data(val) {
  //     this.$emit("img_logo", val);
  //   }
  // },
  methods: {
    deleter(){
      this.MerchantEntrancePhoto=[]
    },
    // deleteafterRead(index, name) {
    //   // console.log(name.index,this.data)
    //   this.data.splice(name.index, 1);
    //   this.MerchantEntrancePhoto.splice(name.index, 1);
    //   // console.log(this.data);
    // },
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      return new Promise((resolve, reject) => {
        let splitArray = file.file.name.split(".");
        let current = moment()
            .format("YYYYMMDD")
            .toString(),
          prefix = moment(file.file.lastModified)
            .format("HHmmss")
            .toString(),
          suffix =
            new Date().getTime() + "." + splitArray[splitArray.length - 1],
          key = encodeURI(`${current}/${prefix}_${suffix}`);
        getUpToken({ key })
          .then(res => {
            let data = new FormData();
            data.append("token", res.data.uptoken);
            data.append("key", key);
            data.append("file", file.file);
            axios({
              url: "//upload.qiniup.com",
              method: "POST",
              data: data,
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
              .then(res => {
                // this.data.push(res.data.domain + res.data.truekey);
                if (res.data) {
                  file.status = "done";
                  file.message = "上传成功...";

                  this.$emit("img_logo", res.data.domain + res.data.truekey);
                  this.$emit("img_indoor", res.data.domain + res.data.truekey);
                  this.$emit(
                    "img_contract",
                    res.data.domain + res.data.truekey
                  );
                  this.$emit("img_other", res.data.domain + res.data.truekey);
                  this.$emit(
                    "img_idcard_holding",
                    res.data.domain + res.data.truekey
                  );
                  this.$emit(
                    "img_open_permits",
                    res.data.domain + res.data.truekey
                  );
                  this.$emit(
                    "img_org_code",
                    res.data.domain + res.data.truekey
                  );
                  this.$emit("img_tax_reg", res.data.domain + res.data.truekey);
                  this.$emit(
                    "img_unincorporated",
                    res.data.domain + res.data.truekey
                  );
                  this.$emit(
                    "img_sub_account_promiss",
                    res.data.domain + res.data.truekey
                  );
                }
              })
              .catch(err => {
                reject(err);
                file.status = "failed";
                file.message = "上传失败";
              });
          })
          .catch(error => {
            file.status = "failed";
            file.message = "上传失败";
            reject(error);
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>